import { ImmapApi } from '../../../api/ImmapApi';
import { OrganizationContext } from '../../../contexts/OrganizationContext';
import { GTDCredentials } from '../../../interfaces/GTDCredentials';
import {
	SovosButton,
	SovosLinearProgress,
	SovosMenuItem,
	SovosPageLayout,
	SovosSelect,
	SovosTextField,
} from 'mosaic-react';
import React, { useContext, useEffect, useState } from 'react';

const initialState = {
	userName: '',
	hmacKey: '',
	segHash: '',
	passKey: '',
	gtdOrgName: '',
	gtdOrgCode: '',
	volume: 'L',
};

const GTDCredentialsPage: React.FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [credentials, setCredentials] = useState<GTDCredentials>(initialState);
	const { selectedOrg } = useContext(OrganizationContext);

	const saveCredentials = async () => {
		setIsLoading(true);
		await ImmapApi.saveCredentials(credentials).finally(() => setIsLoading(false));
	};

	useEffect(() => {
		const getCredentials = async () => {
			setIsLoading(true);
			await ImmapApi.fetchCredentials()
				.then((response: GTDCredentials) => {
					if (response) {
						setCredentials(response);
					}
				})
				.finally(() => setIsLoading(false));
		};
		getCredentials();
	}, [selectedOrg]);

	return (
		<SovosPageLayout pageTitle='GTD Credentials'>
			{isLoading && <SovosLinearProgress variant='indeterminate' />}
			<div
				style={{
					width: '30%',
					paddingLeft: 20,
					display: 'flex',
					flexDirection: 'column',
					filter: isLoading ? 'blur(3px)' : '',
				}}
			>
				<SovosTextField
					id='gtdOrgName'
					name='gtdOrgName'
					label='GTD Organization Name'
					value={credentials.gtdOrgName}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setCredentials({ ...credentials, gtdOrgName: event.target.value });
					}}
					margin='normal'
					variant='outlined'
					required
				/>
				<SovosTextField
					id='gtdOrgCode'
					name='gtdOrgCode'
					label='GTD Organization Code'
					value={credentials.gtdOrgCode}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setCredentials({ ...credentials, gtdOrgCode: event.target.value });
					}}
					margin='normal'
					variant='outlined'
					required
				/>
				<SovosTextField
					id='userName'
					name='userName'
					label='GTD User'
					value={credentials.userName}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setCredentials({ ...credentials, userName: event.target.value });
					}}
					margin='normal'
					variant='outlined'
					required
				/>
				<SovosTextField
					id='passKey'
					name='passKey'
					label='Password'
					type='password'
					value={credentials.passKey}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setCredentials({ ...credentials, passKey: event.target.value });
					}}
					variant='outlined'
					margin='normal'
				/>
				<SovosTextField
					id='hmacKey'
					name='hmacKey'
					label='GTD HMAC'
					type='password'
					value={credentials.hmacKey}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setCredentials({ ...credentials, hmacKey: event.target.value });
					}}
					margin='normal'
					variant='outlined'
					required
				/>
				<SovosSelect
					id='volume'
					name='volume'
					label='Upload Volume'
					value={credentials.volume}
					variant='outlined'
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setCredentials({ ...credentials, volume: event.target.value });
					}}
				>
					<SovosMenuItem value={'L'}>L</SovosMenuItem>
					<SovosMenuItem value={'H'}>H</SovosMenuItem>
				</SovosSelect>
				<div style={{ display: 'flex', justifyContent: 'end' }}>
					<SovosButton key='save-credentials' disabled={false} onClick={() => saveCredentials()}>
						Save
					</SovosButton>
				</div>
			</div>
		</SovosPageLayout>
	);
};

export default GTDCredentialsPage;
